import { d as o } from "./chunk-debounce-Bk6yKvzA.js";
const { Shopify: l } = window;
document.addEventListener("DOMContentLoaded", () => {
  c(), d();
});
const d = () => {
  document.addEventListener("click", (t) => {
    const e = t.target;
    e && e.tagName === "A" && l.analytics.publish("link_click", {
      link_classes: e.className,
      link_domain: e.href ? new URL(e.href).hostname : "",
      link_id: e.id,
      link_url: e.href,
      outbound: e.target === "_blank"
    });
  });
}, r = () => {
  const t = Math.round(
    window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100
  ), e = [10, 25, 50, 75].reverse();
  for (let n = 0; n < e.length; n++)
    if (t >= e[n]) {
      l.analytics.publish("scroll_depth", {
        percent_scrolled: e[n]
      });
      break;
    }
}, i = o(r.bind(void 0), 100), c = () => {
  window.addEventListener("scroll", i);
};
